import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { WatchAccountService } from '../../../../services/watch-account.service';
import { AccountService } from '../../../../services/account.service';
import { ModalCreateFunnelComponent } from '../../../modals/create-funnel/modal-create-funnel.component';
import { IFunnel, IAccount, IInbox } from '../../../../interfaces/graph-types';
import { Observable, Subscription, BehaviorSubject, Subject } from 'rxjs';
import {
  trigger,
  style,
  transition,
  animate,
  keyframes,
  query,
  stagger,
} from '@angular/animations';
import { GlobalWindow } from '../../../../main.window';
import gql from 'graphql-tag';
import { PaginationTemplate } from '../../../../interfaces/pagination';
import { Apollo } from 'apollo-angular-boost';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

declare let window: GlobalWindow;

@Component({
  selector: '[account-funnels-list]',
  template: require('./account-funnels-list.component.pug'),
  styles: [require('./account-funnels-list.component.css').toString()],
  /*
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),

        query(
          ':enter',
          stagger('100ms', [
            animate(
              '0.4s ease-in',
              keyframes([
                style({
                  opacity: 0,
                  transform: 'translateY(+100%)',
                  offset: 0,
                }),
                style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
              ]),
            ),
          ]),
          { optional: true },
        ),
      ]),
    ]),
  ],
  */
})
export class AccountFunnelsListComponent implements OnInit {
  bsModalRef: BsModalRef;
  img_empty = require('./empty.png');

  // -------------------------------------------------------------------
  constructor(
    private modalService: BsModalService,
    private watch: WatchAccountService,
    private apollo: Apollo,
  ) {
    this.countTotal = new BehaviorSubject<number>(0);
  }

  itemPerPage = 30;
  maxSize = 10;
  currentPage: number = 1;
  highlightFunnel: IFunnel = null;
  totalCount = null;

  // -------------------------------------------------------------------
  isLoading() {
    return this.funnelPagination.isLoading();
  }

  // -------------------------------------------------------------------
  buildQuery() {
    return this.apollo.watchQuery<{ account: IAccount }>({
      query: gql`
        query funnelPagination(
          $first: Int
          $last: Int
          $after: String
          $before: String
          $skip: Int
          $accountId: ID!
          $searchFilter: String
          $archived: Boolean
          $logonId: ID
        ) {
          account(accountId: $accountId) {
            id
            funnelList(
              first: $first
              last: $last
              after: $after
              before: $before
              skip: $skip
              searchFilter: $searchFilter
              archived: $archived
              logonId: $logonId
            ) {
              totalCount
              pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  id
                  name
                  description
                  live
                  applicationCount
                  sharing
                  createdAt
                  owner {
                    id
                    name
                  }
                  preview
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: false,
    });
  }

  searchFilter = { include_tags: [], in_group: null };
  searchChanged: Subject<any> = new Subject<any>();

  // -------------------------------------------------------------------
  setPage(newPage: number) {
    if (this.currentPage == newPage) {
      return;
    }
    this.currentPage = newPage;
    this.funnelPagination.setOffset((newPage - 1) * this.itemPerPage);
  }

  filter: string = '';

  archived = false;
  mine = false;

  funnelPagination: PaginationTemplate<IFunnel>;
  private accountId$: Subscription;
  accountId: string;

  countTotal: BehaviorSubject<number>;

  // -------------------------------------------------------------------
  ngOnInit() {
    let logonId = null;
    if (this.mine) {
      logonId = window.logonId;
    }
    const query = this.buildQuery();

    this.accountId$ = this.watch.accountId().subscribe(accountId => {
      this.accountId = accountId;

      this.funnelPagination = new PaginationTemplate<IFunnel>(
        this.apollo,
        this.accountId,
        query,
        'account',
        'funnelList',
        null,
        null,
        this.searchFilter,
        () => {
          if (this.totalCount == null) {
            this.totalCount = this.funnelPagination.totalCount; // to prevent that an empty search displays that the org has no account at all
          }
          this.countTotal.next(this.funnelPagination.totalCount);
        },
      );
    });

    this.searchChanged
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(model => this.startSearch(model));
  }

  // -------------------------------------------------------------------
  mouseEnter(day, index) {}

  // -------------------------------------------------------------------
  mouseLeave() {}

  // -------------------------------------------------------------------
  valueChanged(newvalue) {
    this.searchChanged.next(newvalue);
  }

  // -------------------------------------------------------------------
  startSearch(newvalue) {
    this.filter = newvalue;
    this.funnelPagination.searchFilter.text = newvalue;
    this.funnelPagination.setOffset(0, () => {});
  }

  // -------------------------------------------------------------------
  viewArchived(
    _data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.archived = !this.archived;
    let logonId = null;
    if (this.mine) {
      logonId = window.logonId;
    }

    this.currentPage = 1;
    this.funnelPagination.variables.archived = this.archived;
    this.funnelPagination.setOffset(0, () => {});

    onsuccess();
  }

  // -------------------------------------------------------------------
  viewMine(_data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.mine = !this.mine;

    let logonId = null;
    if (this.mine) {
      logonId = window.logonId;
    }

    this.currentPage = 1;
    this.funnelPagination.variables.logonId = logonId;
    this.funnelPagination.setOffset(0, () => {});

    onsuccess();
  }

  // -------------------------------------------------------------------
  trackByFn(index, item) {
    // https://medium.freecodecamp.org/best-practices-for-a-clean-and-performant-angular-application-288e7b39eb6f
    return item.id; // unique id corresponding to the item
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {}

  // -------------------------------------------------------------------
  OpenCreateFunnelModal() {
    //this.accountService.account().subscribe(response => {
    const options: ModalOptions = new ModalOptions();

    options.class = 'gray modal-lg';
    options.ignoreBackdropClick = true;
    options.initialState = {
      org_id: 0, //response.organization.id,
    };
    this.bsModalRef = this.modalService.show(
      ModalCreateFunnelComponent,
      options,
    );
    this.bsModalRef.content.closeBtnName = 'Close';
    //});
  }
}
